// extracted by mini-css-extract-plugin
module.exports = {"titlePopUp":"styles_titlePopUp__IDtqX"};